import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class RoleService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getRoles() {
        return this.http.get(this.baseUrl + '/api/Role/GetRoles');
    }
}
